/**
 * <pre>
 * UgcWall module.
 *
 * This module is responsible for all UgcWall related logic.
 *
 * Summary of responsibilities:
 *
 *  - defines app interface
 *  - inits app
 * </pre>
 *
 * @author Tim Loram
 * @module UgcWall
 */

// Import all modules that make up a UgcWall module.
import Components from './components.js';
import App from './app.js';

// Init the app.
App.init();

/**
 * <pre>
 * UgcWall public interface.
 *
 * All interactions between different app modules should only happen via this interface, so only export
 * components, methods etc. that you intend to be public.
 *
 * Allows us to more clearly define and document how an app module should behave.
 * </pre>
 *
 * @type {Object}
 * @property {Object} Components React components that this app renders.
 */
const Interface = {
	Components: Components
}

export default Interface;